import { render, staticRenderFns } from "./ParcelDetailShippingLabel.vue?vue&type=template&id=490259e3&"
import script from "./ParcelDetailShippingLabel.vue?vue&type=script&lang=js&"
export * from "./ParcelDetailShippingLabel.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDetailShippingLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports